import { Link } from 'react-router-dom'
import { Stack, Typography } from '@mui/material'
import Chip from 'components/Chip/Chip'

const ChipsPanel = ({ items }) => {
  return (
    <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
      <Typography variant="body1" sx={{ opacity: 0.4, pr: 1 }}>
        Треки:
      </Typography>
      {items.map((item, index) => (
        <Chip
          key={index}
          component={Link}
          label={item.label}
          to={item.href}
          color={item.color}
        />
      ))}
    </Stack>
  )
}

export default ChipsPanel
